exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "footer.footer-container {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  height: auto;\n  justify-content: center;\n  font-size: 0.7em;\n  text-align: center;\n  color: #929292;\n  width: auto;\n  left: 45%;\n  margin-top: 5px; }\n  footer.footer-container.hide {\n    display: none; }\n", ""]);

